import {PremiumLicensesAttrs} from '@freckle/educator-entities/ts/common/models/premium-licenses'
import {TeacherAttrs} from '@freckle/classroom/ts/users/models/teacher'
import {NavbarComponent} from './navbar'

type Props = {
  teacher: TeacherAttrs
  premiumLicenses: PremiumLicensesAttrs
}

export function NavbarContainer(props: Props) {
  const {teacher, premiumLicenses} = props
  return <NavbarComponent {...{teacher, premiumLicenses}} />
}
